import { useAppSelector } from '../hooks';

export const useQuotesData = () => {
  return useAppSelector(state => ({ ...state.quotes }));
};
